import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, params) {
        state.list = params.list;
        state.selectList = params.selectList;
    },
};

const actions = {
    getList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('categoriasservicios/list')
                .then(res => {
                    let selectList = res.data.map(documentoTipo => documentoTipo.nombre.trim());

                    let params = {
                        list: res.data,
                        selectList
                    }
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}